import React, { useEffect } from 'react';

const AdBanner = ({ slotId, format = 'auto', responsive = true, style = {} }) => {
    useEffect(() => {
        try {
            if (process.env.NODE_ENV !== 'development') {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            }
        } catch (err) {
            console.error('AdSense error:', err);
        }
    }, []);

    if (process.env.NODE_ENV === 'development') {
        return (
            <div
                className="bg-slate-200 border-2 border-dashed border-slate-400 p-4 text-center text-slate-500 rounded-lg my-4"
                style={{ minHeight: '100px', ...style }}
            >
                <div className="font-bold text-sm">Google Ad Placeholder</div>
                <div className="text-xs">Slot ID: {slotId || 'MISSING'}</div>
                <div className="text-xs mt-1">(Ads are hidden in localhost)</div>
            </div>
        );
    }

    return (
        <div className="ad-container my-4 text-center overflow-hidden">
            <ins
                className="adsbygoogle"
                style={{ display: 'block', ...style }}
                data-ad-client={process.env.REACT_APP_ADSENSE_CLIENT_ID}
                data-ad-slot={slotId}
                data-ad-format={format}
                data-full-width-responsive={responsive ? 'true' : 'false'}
            />
        </div>
    );
};

export default AdBanner;
